import { render, staticRenderFns } from "./WidgetGroup.vue?vue&type=template&id=34027aa6&"
import script from "./WidgetGroup.vue?vue&type=script&lang=js&"
export * from "./WidgetGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports